import { CardHeader } from '@mui/material';

import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  /* istanbul ignore next */ (theme) => ({
    title: theme.typography.h1,
    content: {},
    avatar: {},
  }),
  { classNamePrefix: 'CardTitle' }
);

const CardTitle = ({ children, decoration = null, subtitle = null, ...props }) => {
  const classes = useStyles(props);

  return (
    <CardHeader
      {...props}
      classes={classes}
      avatar={decoration}
      title={children}
      subheader={subtitle}
    />
  );
};

export default CardTitle;
